<template>
	<div class="auditMsg" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="title-main">
			<h3>运动员管理</h3>
		</div>
		<el-form :inline="true" :model="formInline" class="demo-form-inline">
		  <el-form-item label="姓名：">
		    <el-input v-model="formInline.memberName" placeholder="请输入姓名" class="el-input_height"></el-input>
		  </el-form-item>
		  <el-form-item label="出生年：" style="width:500px;">
		    <el-select  v-model="formInline.bithStartDate" placeholder="出生日期开始" @change="selectStar" clearable>
		      <el-option
		      	v-for="item in option"
		      	:key="item.value"
		        :label="item.label"
		        :value="item.value">
		      </el-option>
		    </el-select>
		    <span>到</span>
		    <el-select v-model="formInline.bithEndDate" placeholder="出生日期结束" clearable>
		      <el-option
		      	v-for="item in optionend"
		      	:key="item.value"
		        :label="item.label"
		        :value="item.value"></el-option>
		    </el-select>
		  </el-form-item>
		  <el-form-item style="width:240px; margin: 0;">
		  	  <el-radio-group v-model="formInline.memberSex">
			    <el-radio label="">全部</el-radio>
			    <el-radio :label="0">男</el-radio>
			    <el-radio :label="1">女</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <el-form-item style="width:240px; margin: 0;">
		  	  <el-radio-group v-model="formInline.memberLevel">
			    <el-radio label="">全部</el-radio>
			    <el-radio :label="1">专业</el-radio>
			    <el-radio :label="0">大众</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <el-form-item style="width:300px;margin: 0;">
		  	  <el-radio-group v-model="formInline.memberWeapon" @change="change">
		  	  	<el-radio label="" >全部</el-radio>
			    <el-radio :label="1">花剑</el-radio>
			    <el-radio :label="2">重剑</el-radio>
			    <el-radio :label="3">佩剑</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <el-form-item style="width:80px;margin:0 20px;">
		    <el-button type="primary" @click="onSubmit" class="bb" round>查询</el-button>
		  </el-form-item>
		</el-form>
		<div class="table clear">
			<el-button type="primary" @click="openAddDialog" class="bb" round >增加人员</el-button>
			<a type="primary" href="/marlin/sign/data/club/member/export" style="border-radius: 20px;" class="el-button el-button--primary bb">导出EXCEL</a>
			<span style="float: right;line-height: 50px;">共{{person}}人</span>
		</div>

		<div class="elTable">
			<el-table
			    :data="tableData"
			    border
			    resizable="false"
			    @cell-mouse-enter="cellMouseEnter"
			    @cell-mouse-leave="cellMouseLeave"
			    style="width: 100%">
			    <el-table-column
			      label="姓名"
			      align="center">
			      <template slot-scope="scope" >
			      	<div >
				      	<span style="color: #44c1de;cursor: pointer;" @click="handleEdit(scope.$index, scope.row)"> {{scope.row.memberName}}</span>
			      	</div>

			      </template>
			    </el-table-column>
			    <el-table-column
			      label="性别"
			      width="60"
			      align="center">
			       <template slot-scope="scope">
			        <span style="margin-left: 10px">{{scope.row.memberSex | sexToData}}</span>
			      </template>
			    </el-table-column>
			    <el-table-column
			      prop="memberIdCard"
			      label="证件号码"
			      width="180"
			      align="center">
			    </el-table-column>
			    <el-table-column
			      label="出生日期"
			      width="120"
			      align="center">
			      <template slot-scope="scope">
			        <span style="margin-left: 10px">{{scope.row.memberBith | timestampToDate}}</span>
			      </template>

			    </el-table-column>

			    <el-table-column
			      label="等级"
			      width="80"
			      align="center">
					 <template slot-scope="scope">
				        <span style="margin-left: 10px">{{scope.row.memberLevel | levelTodata}}</span>
				      </template>
			    </el-table-column>
			    <el-table-column
			      label="剑种"
			      width="80"
			      align="center">
			          <template slot-scope="scope">
				        <span style="margin-left: 10px">{{scope.row.memberWeapon | WeaponToData}}</span>
				      </template>
			    </el-table-column>

				<el-table-column
			      label="持剑手"
			      width="80"
			      align="center">
			      	  <template slot-scope="scope">
				        <span style="margin-left: 10px">{{scope.row.memberWay | memberWayToData}}</span>
				      </template>
			   </el-table-column>

			    <el-table-column label="操作"
			    	fixed="right"
			    	width="100"
			    	align="center">
			      <template slot-scope="scope">
			      	<div v-if="(scope.row.allowOper)==1" >
				        <el-button
				          size="mini"
				          type="danger"
				          icon="el-icon-delete"
				          @click="handleDelete(scope.$index, scope.row)"
				          v-if="scope.row.id==0"
				          ></el-button>
				        <el-button
				          size="mini"
				          type="info"
				          icon="el-icon-delete"
				          @click="handleDelete(scope.$index, scope.row)"
				          v-else
				          ></el-button>
			        </div>

			        <div v-else>
			        		暂无操作
			        </div>
			      </template>
			    </el-table-column>
			  </el-table>
		</div>
		<!--增加人员-->
		<el-dialog title="增加人员" :visible.sync="dialogFormVisible" width="750px">
		  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			  <el-form-item label="姓名" prop="memberName" style="display: inline-block;">
			    <el-input v-model="ruleForm.memberName" :maxlength="50" placeholder="请输入姓名"></el-input>
			  </el-form-item>
			  <el-form-item label="性别" prop="memberSex" style="display: inline-block;">
			    <el-radio-group v-model="ruleForm.memberSex">
			      <el-radio label="0" >男</el-radio>
			      <el-radio label="1" >女</el-radio>
			  	</el-radio-group>
			  </el-form-item>
        <el-form-item label="证件类型" prop="memberIdType" style="display: inline-block;">
          <el-radio-group v-model="ruleForm.memberIdType" @change="memberIdTypeChange">
            <el-radio label="0" >身份证</el-radio>
            <el-radio label="1" >其他证件</el-radio>
          </el-radio-group>
        </el-form-item>
			  <el-form-item v-if="ruleForm.memberIdType==0" label="身份证号码" prop="memberIdCard" style="display: inline-block;">
			    <el-input v-model="ruleForm.memberIdCard" :blur="changeCount()" :maxlength="18" placeholder="请输入身份证号码"></el-input>
			  </el-form-item>
        <el-form-item v-else label="证件号码"  style="display: inline-block;" prop="memberIdCard">
          <el-input v-model="ruleForm.memberIdCard" :maxlength="50" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.memberIdType==0" label="生日" prop="memberBith" style="display: inline-block;">
          <template slot-scope="scope">
            <el-date-picker
              v-model="ruleForm.memberBith"
              type="date"
              disabled
              placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-form-item>
        <el-form-item v-else label="生日" prop="memberBith" style="display: inline-block;">
          <template slot-scope="scope">
            <el-date-picker
              v-model="ruleForm.memberBith"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-form-item>
			  <el-form-item label="身高(CM)" prop="memberHeight" style="display: inline-block;">
			    <el-input v-model.number="ruleForm.memberHeight" style="width: 100px;" type="number" placeholder="身高"></el-input>
			  </el-form-item>
			  <el-form-item label="体重(KG)" prop="memberWeight"  style="display: inline-block;">
			    <el-input v-model.number="ruleForm.memberWeight" style="width: 100px;" :maxlength="3" type="number" placeholder="体重"></el-input>
			  </el-form-item>
			  <el-form-item label="运动员等级" prop="memberLevel">
			    <el-radio-group v-model="ruleForm.memberLevel">
			      <el-radio label="0" >大众</el-radio>
			      <el-radio label="1" >专业</el-radio>
			  	</el-radio-group>
			  </el-form-item>
			  <el-form-item label="剑种" prop="memberWeapon">
			    <el-radio-group v-model="ruleForm.memberWeapon">

			      <el-radio label="1" >花剑</el-radio>
			      <el-radio label="2" >重剑</el-radio>
			      <el-radio label="3" >佩剑</el-radio>
			  	</el-radio-group>
			  </el-form-item>
			  <el-form-item label="持剑手" prop="memberWay">
			    <el-radio-group v-model="ruleForm.memberWay">
			      <el-radio label="0" >未知</el-radio>
			      <el-radio label="1" >左手</el-radio>
			      <el-radio label="2" >右手</el-radio>
			  	</el-radio-group>
			  </el-form-item>
        <el-form-item label="监护人姓名" prop="memberContactName"  style="display: inline-block;">
          <el-input v-model="ruleForm.memberContactName" :maxlength="50" placeholder="请输入监护人姓名" ></el-input>
        </el-form-item>
        <el-form-item label="监护人手机" prop="memberContactTel" style="display: inline-block;">
          <el-input v-model="ruleForm.memberContactTel" :maxlength="11" placeholder="请输入监护人手机"></el-input>
        </el-form-item>
        <el-form-item label="监护人身份证" prop="memberContactIdcard" style="display: inline-block;">
          <el-input v-model="ruleForm.memberContactIdcard" :maxlength="18" placeholder="请输入监护人身份证" ></el-input>
        </el-form-item>
        <el-form-item label="监护人邮箱" prop="memberContactEmail" style="display: inline-block;">
          <el-input v-model="ruleForm.memberContactEmail" :maxlength="50" placeholder="请输入监护人邮箱" ></el-input>
        </el-form-item>
        <el-form-item label="家庭地址" prop="memberContactAddress" style="display: inline-block;width: 680px;">
          <el-input v-model="ruleForm.memberContactAddress" :maxlength="100" placeholder="请输入家庭地址" ></el-input>
        </el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer" >
			    <el-button type="primary" @click="submitForm('ruleForm')" class="bb"round>添加</el-button>
			    <el-button @click="cancle" round >取消</el-button>
			</div>
		</el-dialog>
		<!--修改人员-->
		<el-dialog title="修改人员" :visible.sync="editFormVisible"  width="750px">
		  <el-form :model="editForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			  <el-form-item label="姓名" prop="memberName" style="display: inline-block;">
			    <el-input v-model="editForm.memberName" :maxlength="50" placeholder="请输入姓名" :disabled="disabled1"></el-input>
			  </el-form-item>
			  <el-form-item label="性别" prop="memberSex" style="display: inline-block;">
			    <el-radio-group v-model="editForm.memberSex" :disabled="disabled1">
			      <el-radio label="0" >男</el-radio>
			      <el-radio label="1" >女</el-radio>
			  	</el-radio-group>
			  </el-form-item>
        <el-form-item label="证件类型" prop="memberIdType" style="display: inline-block;">
          <el-radio-group v-model="editForm.memberIdType" :disabled="disabled1" @change="memberIdTypeChange">
            <el-radio label="0" >身份证</el-radio>
            <el-radio label="1" >其他证件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="editForm.memberIdType==0" label="身份证号码" prop="memberIdCard" style="display: inline-block;">
          <el-input v-model="editForm.memberIdCard" :disabled="disabled1" :blur="changeCount1()" :maxlength="18" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item v-else label="证件号码" style="display: inline-block;" prop="memberIdCard">
          <el-input v-model="editForm.memberIdCard" :maxlength="50" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.memberIdType==0" label="生日" prop="memberBith" style="display: inline-block;">
          <template slot-scope="scope">
            <el-date-picker
              v-model="editForm.memberBith"
              type="date"
              placeholder="选择日期"
              disabled>
            </el-date-picker>
          </template>
        </el-form-item>
        <el-form-item v-else label="生日" prop="memberBith"  style="display: inline-block;">
          <template slot-scope="scope">
            <el-date-picker
              v-model="editForm.memberBith"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-form-item>
			  <el-form-item label="身高CM" prop="memberHeight" style="display: inline-block;">
			    <el-input v-model.number="editForm.memberHeight"type="number" :disabled="disabled1" style="width: 100px;"   placeholder="身高" :maxlength="3"></el-input>
			  </el-form-item>
			  <el-form-item label="体重KG" prop="memberWeight"style="display: inline-block;">
			    <el-input v-model.number="editForm.memberWeight"type="number" :disabled="disabled1" style="width: 100px;"   :maxlength="3" placeholder="体重"></el-input>
			  </el-form-item>
			  <el-form-item label="运动员等级" prop="memberLevel">
			    <el-radio-group v-model="editForm.memberLevel" :disabled="disabled1">
			      <el-radio label="0" >大众</el-radio>
			      <el-radio label="1" >专业</el-radio>
			  	</el-radio-group>
			  </el-form-item>
			  <el-form-item label="剑种" prop="memberWeapon">
			    <el-radio-group v-model="editForm.memberWeapon" :disabled="disabled1">
			      <el-radio label="1" >花剑</el-radio>
			      <el-radio label="2" >重剑</el-radio>
			      <el-radio label="3" >佩剑</el-radio>
			  	</el-radio-group>
			  </el-form-item>
			  <el-form-item label="持剑手" prop="memberWay">
			    <el-radio-group v-model="editForm.memberWay" :disabled="disabled1">
			      <el-radio label="0" >未知</el-radio>
			      <el-radio label="1" >左手</el-radio>
			      <el-radio label="2" >右手</el-radio>
			  	</el-radio-group>
			  </el-form-item>
			  <el-form-item label="监护人姓名" prop="memberContactName"  style="display: inline-block;">
			    <el-input v-model="editForm.memberContactName" :maxlength="50" placeholder="请输入监护人姓名" ></el-input>
			  </el-form-item>
			  <el-form-item label="监护人手机" prop="memberContactTel" style="display: inline-block;">
			    <el-input v-model="editForm.memberContactTel" :maxlength="11" placeholder="请输入监护人手机"></el-input>
			  </el-form-item>
        <el-form-item label="监护人身份证" prop="memberContactIdcard" style="display: inline-block;">
          <el-input v-model="editForm.memberContactIdcard" :maxlength="18" placeholder="请输入监护人身份证" ></el-input>
        </el-form-item>
        <el-form-item label="监护人邮箱" prop="memberContactEmail" style="display: inline-block;">
          <el-input v-model="editForm.memberContactEmail" :maxlength="50" placeholder="请输入监护人邮箱" ></el-input>
        </el-form-item>
        <el-form-item label="家庭地址" prop="memberContactAddress" style="display: inline-block;width: 680px;">
          <el-input v-model="editForm.memberContactAddress" :maxlength="100" placeholder="请输入家庭地址" ></el-input>
        </el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer" style="text-align:center">
			    <el-button type="primary" @click="editFormSubmit('ruleForm')" round class="bb" style="color: #fff;border:1px solid #44c1de" v-if="(editForm.allowOper)==1">修改</el-button>
        <el-button type="primary" @click="editFormSubmitContact('ruleForm')" round class="bb" style="color: #fff;border:1px solid #44c1de" v-else>修改监护人</el-button>
			    <el-button @click="editFormVisible = false" round>取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
	    data() {
	    	let IdentityCodeValid = function(code) {
            let pass=true
            if(null==code || code.length!=18){
            		pass=false
            }
            if(pass){
				let year=code.substring(6,10)
				let month=code.substring(10,12)
				let days=code.substring(12,14)

				let day31 = [1,3,5,7,8,10,12];
				let day30 = [1,3,4,5,6,7,8,9,10,11,12];

				if(isNaN(year) || isNaN(month) || isNaN(days)){
					pass=false
				}
				let date=new Date()
				if(pass && (parseInt(year) < 1900 || parseInt(year) > date.getFullYear())){
					pass = false;
				}
				if(pass && (parseInt(month) < 1 || parseInt(month) > 12)){
					pass = false;
				}
				if(pass && (parseInt(days) < 1 ||parseInt(days) > 31)){
					pass = false;
				}
				if(pass){
				  if(parseInt(month))
					if(parseInt(days) == 31){
						let findMonth = false;
						for(let i=0;i<day31.length;i++){
							if(parseInt(month) == day31[i]){
								findMonth = true;
								break;
							}
						}
						if(!findMonth){
							pass = false;
						}
					}else if(parseInt(days) == 30){
						let findMonth = false;
						for(let i=0;i<day30.length;i++){
							if(parseInt(month) == day30[i]){
								findMonth = true;
								break;
							}
						}
						if(!findMonth){
							pass = false;
						}
					}else{
						if(parseInt(month) == 2){
							if(parseInt(year)%4 == 0){
								if(parseInt(days) > 29){
									pass = false;
								}
							}else{
								if(parseInt(days) > 28){
									pass = false;
								}
							}
						}
					}

				}

            }

            return pass;
          };
	      return {
	      	clubInfos:JSON.parse(sessionStorage.getItem("clubInfos")),
	      	href:'',
	      	fullscreenLoading: false,
	      	disabled1:false,
	      	userInfos: {},
	        formInline: {
            "memberName":"",//姓名 模糊匹配 选填
            "memberSex":"",//性别 0-男 1-女  全部的时候，不传此参数
            "memberLevel":"",//运动员等级 0-大众 1-专业 全部的时候，不传此参数
            "memberWeapon":"",//剑种 1-花剑 2-重剑 3-配剑全部的时候，不传此参数
            "bithStartDate":"",//出生日期开始
            "bithEndDate":"",//出身日期结束
            "pageSize":10000
	        },
	        option:[],
	        optionend:[],
	        person:null,

	        tableData: [{
		          memberName: '',
		          memberSex:'',
		          memberIdCard:"",
		          memberBith:"",
		          memberHeight:'',
		          memberWeight:'',
		          memberLevel:"",
		          memberWeapon:"",
		          memberWay:"",
		          memberContactName:"",
		          memberContactTel:""
		        }],

	        addForm:{

	        },
	        editFormVisible:false,
	        dialogFormVisible:false,
	        formLabelWidth:'120px',
	        ruleForm: {
		            "memberName":"",//成员姓名 //必填
                "memberSex":"0",//成员性别 0-男 1-女  必填
                "memberIdCard":"",//身份证号码 必填
                "memberBith":"", //出生日期 必填
                "memberHeight":null,//身高 CM 必填
                "memberWeight":null,//体重 KG 必填
                "memberLevel":"0",//运动员等级 0-大众 1-专业 必填
                "memberWeapon":null,//剑种 1-花剑 2-重剑 3-配剑 必填
                "memberWay":null,//持剑手 0-未知 1-左手 2-右手 必填
                "memberContactName":null,//紧急联系人 必填
                "memberContactTel":null,
                "memberIdType":"0"//紧急联系人电话 必填
		        },
		      editForm:{
		            "memberName":"",//成员姓名 //必填
                "memberSex":null,//成员性别 0-男 1-女  必填
                "memberIdCard":"",//身份证号码 必填
                "memberBith":null, //出生日期 必填
                "memberHeight":null,//身高 CM 必填
                "memberWeight":null,//体重 KG 必填
                "memberLevel":null,//运动员等级 0-大众 1-专业 必填
                "memberWeapon":null,//剑种 1-花剑 2-重剑 3-配剑 必填
                "memberWay":null,//持剑手 0-未知 1-左手 2-右手 必填
                "memberContactName":null,//紧急联系人 必填
                "memberContactTel":null,//紧急联系人电话 必填
                "memberIdType":"0"
		        },
		      rules: {
		          memberName: [
		            { required: true, message: '请输入姓名', trigger: 'blur' },
		          ],
              memberBith: [
                {required: true, message: '请输入生日', trigger: 'blur' },
              ],
		          memberSex: [
		            { required: true, message: '请选择性别', trigger: 'change' }
		          ],
              memberIdType:[
                { required: true, message: '请选择证件类型', trigger: 'change' }
              ],
              otherIdCard:[
                { required: true, message: '请输入证件号码', trigger: 'blur' },
              ],
		          memberIdCard:[
		            { required: true, message: '请输入证件号码', trigger: 'blur' },
		          ],
		          memberHeight:[
		            {validator:function(rule,value,callback){
			            if(value<0){
			                callback(new Error("请输入正确的身高"));
			            }else{
			                callback();
			            }
			        }, trigger: 'blur'}
		          ],
		          memberWeight:[
		            {validator:function(rule,value,callback){
			            if(value<0){
			                callback(new Error("请输入正确的体重"));
			            }else{
			                callback();
			            }
			        }, trigger: 'blur'}
		          ],
		          memberLevel: [
		            { required: true, message: '请选择运动员等级', trigger: 'change' }
		          ],
		          memberWeapon: [
		            { required: true, message: '请选择剑种', trigger: 'change' }
		          ],
		          memberWay: [
		            { required: true, message: '持剑手', trigger: 'change' }
		          ],
		          memberContactName:[
		            { required: true, message: '请输入监护人姓名', trigger: 'blur' },
                { min: 1, max: 10, message: '长度在 1 到 10 个字', trigger: 'blur' }
		          ],
		          memberContactTel:[
		            { required: true, message: '请输入监护人手机', trigger: 'blur' },
                {validator:function(rule,value,callback){
                    if((value+"").length != 11 || isNaN(value)){
                      callback(new Error("请输入正确的监护人手机"));
                    }else{
                      callback();
                    }
                  }, trigger: 'blur'}
		          ],
              memberContactIdcard:[
                { required: true, message: '请输入监护人身份证', trigger: 'blur' },
                { min: 18, max: 18, message: '监护人身份证长度为18', trigger: 'blur' }
              ],
              memberContactEmail:[
                { required: true, message: '请输入监护人邮箱', trigger: 'blur' },
                { min: 3, max: 50, message: '长度在 3 到 50 个字', trigger: 'blur' },
                {validator:function(rule,value,callback){
                    if(value.indexOf('@')<1){
                      callback(new Error("请输入正确的监护人邮箱"));
                    }else{
                      callback();
                    }
                  }, trigger: 'blur'}
              ],
              memberContactAddress:[
                { required: true, message: '请输入家庭地址', trigger: 'blur' },
                { min: 1, max: 50, message: '长度在 1 到 50 个字', trigger: 'blur' }
              ]
		        }
		      };
	    },
	    	filters: {
		    timestampToDate(data) {
		      return global.timestampToDate(data);
		    },
		    levelTodata(val){
		    		return val==0 ? '大众':'专业'
		    },
		    WeaponToData(val){
		    		if(val==1){
		    			return val='花剑'
		    		}else if(val==2){
		    			return val='重剑'
		    		}else if(val==3){
		    			return val='佩剑'
		    		}
		    },
		    sexToData(val){
		    		return val==0 ? '男':'女'
		    },
		    memberWayToData(val){
		    		if(val==0){
		    			return val='未知'
		    		}else if(val==1){
		    			return val='左手'
		    		}else if(val==2){
		    			return val='右手'
		    		}
		    }
		},
	    mounted() {
          this.$store.commit("matchCodeChange","")
		    	for(var i=0;i<70;i++){
            var l=(2018-i)
            var v=(2018-i)+'-01-01'
            var o={value:v,label:l}
            this.option.push(o)

            var vend=(2018-i)+'-12-31'
            var oend={value:vend,label:l}
            this.optionend.push(oend)
		    	}
			this.onSubmit()
		  },

	    methods: {
	      openAddDialog(){
	        this.dialogFormVisible = true
          this.ruleForm = {}
          if(null != this.$refs['ruleForm']){
            this.$refs['ruleForm'].resetFields()
          }
        },
        memberIdTypeChange(){
          this.ruleForm.memberBith=null
          this.ruleForm.memberIdCard=null

          this.editForm.memberIdCard=null
          this.editForm.memberBith=null
          // this.$refs['ruleForm'].resetFields()
          // console.log("form名称:"+this.$refs['ruleForm'].resetFields());
        },
	      onSubmit() {
	      	    var self=this
	       		axios.post('/marlin/sign/data/club/member/query/list',this.formInline)
	       		.then(function(res){
	       			if(res.data.code==0){
	       				self.tableData=res.data.rst

				        self.person=res.data.count
	       			}else{
	       				self.$message({
				          message: res.data.msg,
				          type: 'warning'
				        });
	       			}
	       		})
	       		.catch(function(err){
	       			overdue(err.response,err.response.status,self)
	       		})
	      },
	      //增加人员
	      submitForm(formName) {
	      	var self=this
          if((typeof self.editForm.memberBith) != "object"){
            self.ruleForm.memberBith = global.strToDate(self.ruleForm.memberBith)
          }
	        this.$refs[formName].validate((valid) => {
	          if (valid) {
              let postData=self.ruleForm
              postData.memberBith = self.ruleForm.memberBith
	            axios.post('/marlin/sign/data/club/member/add',postData)
	            .then(function(res){
	            		if(res.data.code==0){
	            			self.dialogFormVisible=false
	            			self.onSubmit()
	            			self.ruleForm={
					            "memberName":"",//成员姓名 //必填
                      "memberSex":'',//成员性别 0-男 1-女  必填
                      "memberIdCard":"",//身份证号码 必填
                      "memberBith":"", //出生日期 必填
                      "memberHeight":null,//身高 CM 必填
                      "memberWeight":null,//体重 KG 必填
                      "memberLevel":"0",//运动员等级 0-大众 1-专业 必填
                      "memberWeapon":null,//剑种 1-花剑 2-重剑 3-配剑 必填
                      "memberWay":null,//持剑手 0-未知 1-左手 2-右手 必填
                      "memberContactName":null,//紧急联系人 必填
                      "memberContactTel":null,//紧急联系人电话 必填
					            "memberIdType":"0"
	            			}
	            		}else{
	            			self.$message({
				          message: res.data.msg,
				          type: 'warning'
				        });
	            		}
	            })
	            .catch(function(res){
	            		overdue(res.response,res.response.status,self)
	            })
	          } else {
	            return false;
	          }
	        });
	      },
	      cancle(){
	      	this.dialogFormVisible=false
	      },
	      //修改
	      editFormSubmit(formName){
	      	var self=this
	        this.$refs[formName].validate((valid) => {
	          if (valid) {
	            var postData={
	            	    "memberCode":self.editForm.memberCode,//成员编码
                    "memberName":self.editForm.memberName,//成员姓名 //必填
                    "memberSex":self.editForm.memberSex,//成员性别 0-男 1-女  必填
                    "memberIdCard":self.editForm.memberIdCard,//身份证号码 必填
                    "memberHeight":self.editForm.memberHeight,//身高 CM 必填
                    "memberWeight":self.editForm.memberWeight,//体重 KG 必填
                    "memberLevel":self.editForm.memberLevel,//运动员等级 0-大众 1-专业 必填
                    "memberWeapon":self.editForm.memberWeapon,//剑种 1-花剑 2-重剑 3-配剑 必填
                    "memberWay":self.editForm.memberWay,//持剑手 0-未知 1-左手 2-右手 必填
                    "memberContactName":self.editForm.memberContactName,//紧急联系人 必填
                    "memberContactTel":self.editForm.memberContactTel,//紧急联系人电话 必填
                    "memberContactIdcard":self.editForm.memberContactIdcard,//紧急联系人深得中 必填
                    "memberContactEmail":self.editForm.memberContactEmail,//紧急联系人邮箱 必填
                    "memberContactAddress":self.editForm.memberContactAddress,//家庭地址 必填
                    "memberIdType":self.editForm.memberIdType,
                    "memberBith": self.editForm.memberBith
	            }
	            axios.post('/marlin/sign/data/club/member/update',postData)
	            .then(function(res){
	            		if(res.data.code==0){
	            			self.editFormVisible=false
	            			self.$message({
	            				message:'修改成功',
	            				type:"success"
	            			})
	            			self.onSubmit()
	            		}else{
	            			self.$message({
				          message: res.data.msg,
				          type: 'warning'
				        });
	            		}
	            })
	            .catch(function(res){
	            		overdue(res.response,res.response.status,self)
	            })
	          } else {
	            return false;
	          }
	        });
	      },
        //修改
        editFormSubmitContact(formName){
          var self=this
          if((typeof self.editForm.memberBith) != "object"){
            self.editForm.memberBith = global.strToDate(self.editForm.memberBith)
          }
          this.$refs[formName].validate((valid) => {

            if (valid) {
              var postData={
                "memberCode":self.editForm.memberCode,//成员编码
                "memberContactName":self.editForm.memberContactName,//紧急联系人 必填
                "memberContactTel":self.editForm.memberContactTel,//紧急联系人电话 必填
                "memberContactIdcard":self.editForm.memberContactIdcard,//紧急联系人深得中 必填
                "memberContactEmail":self.editForm.memberContactEmail,//紧急联系人邮箱 必填
                "memberContactAddress":self.editForm.memberContactAddress,//家庭地址 必填
                "memberIdType":self.editForm.memberIdType
              }
              axios.post('/marlin/sign/data/club/member/updatecontact',postData)
                .then(function(res){
                  if(res.data.code==0){
                    self.editFormVisible=false
                    self.$message({
                      message:'修改成功',
                      type:"success"
                    })
                    self.onSubmit()
                  }else{
                    self.$message({
                      message: res.data.msg,
                      type: 'warning'
                    });
                  }
                })
                .catch(function(res){
                  overdue(res.response,res.response.status,self)
                })
            } else {
              return false;
            }
          });
        },
	      resetForm(formName) {
	        this.$refs[formName].resetFields();
	      },
	      change(val){
	      },
	      //修改框信息
	      handleEdit(index, row) {
	        console.log('row',row)
	        this.editFormVisible=true
          this.editForm = {
            memberName: row.memberName,
            memberSex: ''+row.memberSex,
            memberIdType: ''+row.memberIdType,
            memberIdCard: row.memberIdCard,
            memberBith: new Date(row.memberBith),
            memberHeight: row.memberHeight,
            memberWeight: row.memberWeight,
            memberLevel: ''+row.memberLevel,
            memberWeapon: ''+row.memberWeapon,
            memberWay: ''+row.memberWay,
            memberContactName: row.memberContactName,
            memberContactTel: Number(row.memberContactTel),
            memberContactIdcard: row.memberContactIdcard,
            memberContactEmail: row.memberContactEmail,
            memberContactAddress: row.memberContactAddress,
            memberCode: row.memberCode,
            allowOper: row.allowOper
          }
          console.log(this.editForm)
	        this.disabled1=false
	        if(row.allowOper==1){
	        		 this.disabled1=false
	        }else{
	        		this.disabled1=true
	        }
	      },
	      handleDelete(index, row) {
	      	var self=this
	        this.$confirm('此操作会删除此条记录, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		       }).then(() => {
					axios.get('/marlin/sign/data/club/member/delete/'+row.memberCode)
					.then(function(res){
						if(res.data.code==0){
							self.$message({
								message:'您已删除成功！',
								type:'success'
							})
							self.onSubmit()
						}else{
							self.$message({
								message:res.data.msg,
								type:'warning'
							})
						}
					})
					.catth(function(res){
						overdue(res.response,res.response.status,self)
					})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消删除'
		          });
		        });
	      },
	      timestampToDate(data) {
		      return global.timestampToDate(data);
		    },

	      selectStar(val){
	      },
		  changeCount(){
			    var IdCard=this.ruleForm.memberIdCard
				if(null!=IdCard && IdCard.length == 18){
					var newIdCard=IdCard.substring(6,10)+'-'+IdCard.substring(10,12)+'-'+IdCard.substring(12,14)
					this.ruleForm.memberBith=newIdCard
					IdCard==''
				}else{
					IdCard==''
				}

	     },

	     changeCount1(){
	     	var IdCard=this.editForm.memberIdCard
          if(null!=IdCard && IdCard.length == 18){
            var newIdCard=IdCard.substring(6,10)+'-'+IdCard.substring(10,12)+'-'+IdCard.substring(12,14)
            this.editForm.memberBith=newIdCard
            IdCard==''
          }else{
            IdCard==''
          }
	   		},
		   	cellMouseEnter(row,column,cell,event){
		   		row.id=0
		   	},
		   	cellMouseLeave(row,column,cell,event){
		   		row.id=1
		   	}
	    }
	  }
</script>

<style  lang="less">
	.auditMsg{
		.el-form-item{
			width: 340px;
		}
		.el-input input{
			border-radius:20px !important;
		}
	}

	.table{
		margin-top: 10px;
	}
	.elTable{
		margin-top: 20px;
	}
	.el-form-item{
		margin-bottom: 18px;
	}
	.cell span{
		margin-left: 0 !important;
	}
	.bb{
		background-color: #44c1de;
		border:1px solid #44c1de;
		padding: 8px 15px;
	}
	.el-button{
		padding: 8px 15px !important;
		font-size: 14px;
	}
	.el-radio__input.is-checked+.el-radio__label{
		color: #44c1de;
	}
	.el-radio__input.is-checked .el-radio__inner {
	    border-color: #44c1de;
	    background: #44c1de;
	}
	.el-table th{
        background:rgb(97, 107, 136) !important;
        color: #fff !important;
    }
    .el-table--border{
    		border-radius:10px ;
    }
	.auditMsg .el-input__inner{
		height: 34px !important;
		line-height: 34px !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/auditMsg.vue